module.exports = __webpack_public_path__ + "media/images/icon__facebook-2394858070fc85ac8f32e6425bc082e8.png";